<template>
  <v-dialog v-model="shelfDetailsModal" width="810" scrollable persistent>
    <v-card class="popup">
      <div class="modal-header">
        <div class="modal-header-left">
          <div class="modal-icon-wrap">
            <img src="@/assets/img/camera.png" class="modal-icon" />
          </div>
          <span class="page-title-bar">{{ $t("Shelf Details") }}</span>
        </div>
        <div class="modal-header-right">
          <v-chip small class="info-chip mr-2">
            {{ $t('Shelf') }}: {{ shelfItem.shelfId }}
          </v-chip>
          <v-chip small class="info-chip">
            {{ $t("Floor") }}: {{ shelfItem.floor }}
          </v-chip>
        </div>
      </div>

      <v-card-text class="modal-body">
        <div class="section-label mb-3">
          <v-icon small color="#5a6a7e" class="mr-1">mdi-tune-variant</v-icon>
          {{ $t("Threshold") }}
        </div>

        <div class="config-block mb-4">
          <div class="block-title">
            <v-icon small color="#001e38" class="mr-1">mdi-tag-outline</v-icon>
            {{ $t("ESL") }}
          </div>
          <v-row class="mt-2">
            <v-col cols="6">
              <v-text-field
                v-model="esl.detConfidence"
                :placeholder="$t('Input Locate ESL Threshold')"
                :label="$t('Detect Confidence')"
                outlined
                dense
                hide-details
                clearable
                class="form-input"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="esl.recConfidence"
                :label="$t('Recognition Confidence')"
                :placeholder="$t('Input Locate ESL Threshold')"
                outlined
                dense
                hide-details
                clearable
                class="form-input"
              ></v-text-field>
            </v-col>
          </v-row>
        </div>

        <div class="config-block mb-4">
          <div class="block-title">
            <v-icon small color="#001e38" class="mr-1">mdi-package-variant-closed</v-icon>
            {{ $t("Product") }}
          </div>
          <v-row class="mt-2">
            <v-col cols="6">
              <v-text-field
                v-model="product.detConfidence"
                :label="$t('Detect Confidence')"
                :placeholder="$t('Input Locate Product')"
                outlined
                dense
                hide-details
                clearable
                class="form-input"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="product.misThreshold"
                :label="$t('Misplacement Threshold (MPI)')"
                :placeholder="$t('Input Misplacement Threshold: MPI')"
                outlined
                dense
                hide-details
                clearable
                class="form-input"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="product.clusterMisThreshold"
                :label="$t('Cluster Misplacement Threshold (MPI)')"
                :placeholder="$t('Input Cluster Misplacement Threshold: MPI')"
                outlined
                dense
                hide-details
                clearable
                class="form-input"
              ></v-text-field>
            </v-col>
          </v-row>
        </div>

        <div class="config-block">
          <div class="block-title">
            <v-icon small color="#001e38" class="mr-1">mdi-clipboard-list-outline</v-icon>
            {{ $t("Report Settings") }}
          </div>
          <div class="switch-row mt-3">
            <div class="switch-item">
              <v-switch v-model="isRestockShelf" inset hide-details dense class="form-switch mt-0 pt-0" />
              <span class="switch-label">{{ $t("Restock Shelf") }}</span>
            </div>
            <div class="switch-item">
              <v-switch v-model="reportOOS" inset hide-details dense class="form-switch mt-0 pt-0" />
              <span class="switch-label">{{ $t("OOS Report") }}</span>
            </div>
            <div class="switch-item">
              <v-switch v-model="reportMIS" inset hide-details dense class="form-switch mt-0 pt-0" />
              <span class="switch-label">{{ $t("MIS Report") }}</span>
            </div>
            <div class="switch-item">
              <v-switch v-model="reportLS" inset hide-details dense class="form-switch mt-0 pt-0" />
              <span class="switch-label">{{ $t("LS Report") }}</span>
            </div>
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="modal-actions">
        <v-btn class="btn" @click="handleDefault">
          {{ $t("Default") }}
        </v-btn>
        <v-btn class="btn" @click="handleSave">
          {{ $t("Save") }}
        </v-btn>
        <v-btn class="btn" @click="handleClose">
          {{ $t("Close") }}
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import codes from '@/plugins/codes'
import EventBus from '@/plugins/eventBus'

export default {
  props: ['value', 'shelfItem'],
  data () {
    return {
      shelfDetailsModal: false,
      esl: {
        detConfidence: 0,
        recConfidence: 0
      },
      product: {
        detConfidence: 0,
        misThreshold: 0,
        clusterMisThreshold: 0
      },
      isRestockShelf: false,
      reportLS: false,
      reportMIS: false,
      reportOOS: false,
      defaultConfig: null
    }
  },
  watch: {
    value (value) {
      this.shelfDetailsModal = value
      this.getShelfConfig()
    }
  },
  computed: {
    ...mapGetters({
      store: 'dataStore/GET_SELECTED_STORE'
    })
  },
  methods: {
    assignValues (data) {
      this.esl.detConfidence = data.esl.detConfidence
      this.esl.recConfidence = data.esl.recConfidence
      this.product.clusterMisThreshold = data.product.clusterMisThreshold
      this.product.detConfidence = data.product.detConfidence
      this.product.misThreshold = data.product.misThreshold
      this.reportLS = data.reportLS
      this.reportMIS = data.reportMIS
      this.reportOOS = data.reportOOS
      this.isRestockShelf = data.restockShelf
    },
    async handleDefault () {
      const ok = await this.$confirm.open({
        message:
          'Current settings will be replaced with store defaults. Proceed?'
      })
      if (ok) {
        this.assignValues(this.defaultConfig)
        this.handleSave()
      }
    },
    getShelfConfig () {
      const params = {
        company: this.$store.state.auth.user.company,
        store: this.store.code,
        shelfId: this.shelfItem.shelfId,
        floor: this.shelfItem.floor
      }
      const config = { params: params }
      this.$utils
        .callAxios(
          codes.requests.getShelfConfig.method,
          codes.requests.getShelfConfig.url,
          config
        )
        .then((res) => {
          if (res?.data?.shelves?.length) {
            const shelfInfo = res.data.shelves[0].shelfList[0]
            this.assignValues(shelfInfo)
          }

          if (res?.data?.default) {
            this.defaultConfig = res.data.default
          }
        })
    },
    handleSave () {
      const params = {
        company: this.$store.state.auth.user.company,
        store: this.store.code,
        shelfId: this.shelfItem.shelfId,
        floor: this.shelfItem.floor
      }
      const data = {
        esl: {
          detConfidence: this.esl.detConfidence,
          recConfidence: this.esl.recConfidence
        },
        product: {
          detConfidence: this.product.detConfidence,
          misThreshold: this.product.misThreshold,
          clusterMisThreshold: this.product.clusterMisThreshold
        },
        shelfArea: [],
        isRestockShelf: this.isRestockShelf,
        reportOOS: this.reportOOS,
        reportMIS: this.reportMIS,
        reportLS: this.reportLS
      }
      const config = { params: params }

      this.$utils
        .callAxiosWithBody(
          codes.requests.shelfConfig.method,
          codes.requests.shelfConfig.url,
          data,
          config
        )
        .then((res) => {
          EventBus.$emit('messageAlert', this.$t(res.data.returnMsg))
          this.handleClose()
        })
    },
    handleClose () {
      this.$emit('input', false)
    }
  }
}
</script>

<style scoped>
/* ─── Modal Card ──────────────────────────────────────────── */
.shelf-modal {
  overflow: hidden;
}

/* ─── Header ──────────────────────────────────────────────── */
.popup .page-title-bar {
  margin-bottom: 0;
}
.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
}
.modal-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.modal-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-icon {
  width: 20px;
  height: 20px;
  filter: brightness(10);
}
.modal-title {
  font-size: 18px;
  font-weight: 700;
  color: #001e38;
  letter-spacing: 0.3px;
}
.modal-header-right {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}
.info-chip {
  background: #e8edf2 !important;
  color: #001e38 !important;
  font-weight: 600;
  font-size: 12px;
}

.modal-body {
  padding: 10px 24px !important;
}
.section-label {
  display: flex;
  align-items: center;
  font-size: 11px;
  font-weight: 700;
  color: #5a6a7e;
  text-transform: uppercase;
  letter-spacing: 0.8px;
}

.config-block {
  background: #ffffff;
  border: 1px solid #e0e4ea;
  border-radius: 10px;
  padding: 16px;
}
.block-title {
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: 700;
  color: #001e38;
  letter-spacing: 0.2px;
}
.field-label {
  font-size: 11px;
  font-weight: 600;
  color: #5a6a7e;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
}
::v-deep .config-field .v-input__slot {
  border-radius: 8px !important;
  background: #f8f9fb !important;
}
::v-deep .config-field fieldset {
  border-color: #dde2ea !important;
}
::v-deep .config-field:hover fieldset {
  border-color: #001e38 !important;
}
::v-deep .config-field.v-input--is-focused fieldset {
  border-color: #001e38 !important;
  border-width: 1.5px !important;
}

.switch-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.switch-item {
  display: flex;
  align-items: center;
  gap: 4px;
  background: #f4f6f9;
  border: 1px solid #e0e4ea;
  border-radius: 8px;
  padding: 8px 14px 8px 8px;
  transition: background 0.2s, border-color 0.2s;
  min-width: 140px;
}
.switch-item.switch-active {
  background: #eaf4ec;
  border-color: #28a745;
}
.switch-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
}
::v-deep .switch-item .v-input--switch .v-input--selection-controls__input {
  margin-right: 0;
}

/* ─── Actions ─────────────────────────────────────────────── */
.modal-actions {
  padding: 12px 20px !important;
  display: flex;
  justify-content: center;
}

/* ─── Scrollbar ───────────────────────────────────────────── */
::v-deep ::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::v-deep ::-webkit-scrollbar-track {
  background: #f4f6f9;
  border-radius: 4px;
}
::v-deep ::-webkit-scrollbar-thumb {
  background: #c5cdd6;
  border-radius: 4px;
}
::v-deep ::-webkit-scrollbar-thumb:hover {
  background: #9aa0ac;
}
</style>
